module.exports = __webpack_public_path__ + "img/map.be3c7aac.png";